import AppLink from '@/components/common/AppLink';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import PageCard from '@/components/general/PageCard';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import { blogBg } from '@/functions/formats';
import RateComponent from '@/components/common/RateComponent';
import NearByStore from './NearByStore';
import { shop } from '@/commonTypes';

const stores: shop[] = [
  {
    title: 'روغن‌سرای ونک',
    rating: '۴٫۹',
    distance: '۸۰۰ متر',
    slug: '1',
  },
  {
    title: 'یدک‌سنتر پاسداران',
    rating: '۴٫۸',
    distance: '۱٫۲ کیلومتر',
    slug: '2',
  },
  {
    title: 'لاستیک‌فروشی مرکزی',
    rating: '۴٫۷',
    distance: '۲٫۴ کیلومتر',
    slug: '3',
  },
  {
    title: 'باتری‌سرای اکباتان',
    rating: '۴٫۶',
    distance: '۳٫۱ کیلومتر',
    slug: '6',
  },
  {
    title: 'لوازم‌یدکی صادقیه',
    rating: '۴٫۷',
    distance: '۴٫۰ کیلومتر',
    slug: '4',
  },
  {
    title: 'اکسسوری خودرو نیاوران',
    rating: '۴٫۵',
    distance: '۵٫۲ کیلومتر',
    slug: '5',
  },
];

export default function NearbyStores() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.head}>
        {stores?.length} فروشگاه
        <br />
        نزدیک شما
      </div>

      {stores?.map((store, index) => (
        <NearByStore store={store} index={index} key={index} />
      ))}
    </div>
  );
}
